<template>
    <modal-blue
        :is-open="!!$route.query.welcome"
        @close="closeModal"
    >
        <div
            slot-scope="{ close }"
            class="text-grey-darker"
        >
            <div class="px-4 py-6 border-b sm:px-6">
                <div class="flex flex-col-reverse md:flex-row">
                    <div class="flex-grow md:pr-6">
                        <h1 class="mb-3 text-lg font-normal text-grey-darkest">
                            Welcome home!
                        </h1>

                        <p class="mb-3">
                            You've successfully joined the tenancy at
                            <strong>{{ tenancy.property.address.name }}</strong>!
                        </p>

                        <p>We've let your landlord know that you've accepted their invitation.</p>
                    </div>
                    <div class="flex-none mb-6 text-center md:mb-0 md:mt-3">
                        <div class="w-24 mx-auto">
                            <base-svg
                                slot="image"
                                name="illustration-home"
                                class="w-full"
                            />
                        </div>
                    </div>
                </div>
            </div>

            <div class="px-4 py-3 text-right rounded-b bg-grey-bg sm:px-6">
                <button
                    type="button"
                    class="flex-none w-full btn btn-blue md:w-auto"
                    @click.prevent="close"
                >
                    Go to Tenancy
                </button>
            </div>
        </div>
    </modal-blue>
</template>

<script>
    import _ from 'lodash'

    export default {
        props: {
            tenancy: {
                type: Object,
                required: true
            }
        },
        methods: {
            closeModal () {
                this.$router.replace({
                    query: _.omit(this.$route.query, ['welcome'])
                })
            }
        }
    }
</script>
